import { render, staticRenderFns } from "./categoriesComponent.vue?vue&type=template&id=c49c24e2&scoped=true"
import script from "./categoriesComponent.vue?vue&type=script&lang=js"
export * from "./categoriesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49c24e2",
  null
  
)

export default component.exports